import './styles/RemoveValidateAWBStyle.css';
import React, { useEffect, useCallback, useState } from 'react';
import {
  ControlledNumericInput,
  NavigationButton,
  NumPad,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import AWB from '../../resources/images/awb.png';
import { PackageCandidate } from '../../models/microservices';

const AWB_VALID_LENGTH = 10;
const AWB_FEEDBACK_LENGTH = 'El número de guía es de 10 caractéres';
const AWB_FEEDBACK_NON_EXISTING_PIECE =
  'La pieza ingresada no está en el locker';

const RemoveValidateAWB: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [awbNumber, setAwbNumber] = useState('');
  const [variableInError, setVariableInError] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const lockerContent = useTypedSelector(({ locker }) => {
    return locker.lockerContent;
  });
  const scanner = useTypedSelector(({ devices }) => {
    return devices.scanner;
  });
  const {
    updateRemoveLockerList,
    updateCurrentLockerPosition,
    updateCurrentPackageCandidate,
  } = useActions();
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  const onScan = useCallback(
    (event: CustomEvent) => {
      console.log(event);
      if (!loading && event.detail) {
        let filteredScan = event.detail.replace('\n', '');
        filteredScan = filteredScan.replace('\r', '');
        if (filteredScan.length === AWB_VALID_LENGTH) {
          setAwbNumber(filteredScan);
        }
        let timer = setTimeout(() => {
          scanner?.pullTriggerAsync().catch((error) => console.error(error));
        }, 2000);
        return () => clearTimeout(timer);
      }
    },
    [loading, scanner]
  );
  useEffect(() => {
    const addScannerEventListeners = () => {
      scanner?.addEventListener('scan', onScan as EventListener);
    };
    addScannerEventListeners();
  }, [scanner, onScan]);
  useEffect(
    () => () => {
      const removeScannerEventListeners = () => {
        scanner?.removeEventListener('scan', onScan as EventListener);
      };
      removeScannerEventListeners();
    },
    [scanner, onScan]
  );
  useEffect(() => {
    if (!loading && awbNumber !== '') {
      requestAWBValidation();
    }
  }, [loading, awbNumber]);
  const requestAWBValidation = async () => {
    if (awbNumber.length < AWB_VALID_LENGTH) {
      setFeedbackMessage(AWB_FEEDBACK_LENGTH);
      return;
    }
    setLoading(true);
    if (isAWBInRemoveList()) {
      history.replace(`/${navigationPages.REMOVE_PIECE}`);
      return;
    }
    setAwbNumber('');
    setLoading(false);
  };
  const isAWBInRemoveList = () => {
    let positionWithAWB = lockerContent.find(
      (position) => position.packageCandidate?.awbNumber === awbNumber
    );
    console.log(positionWithAWB);

    if (positionWithAWB) {
      updateRemoveLockerList([positionWithAWB]);
      updateCurrentLockerPosition(positionWithAWB);
      updateCurrentPackageCandidate(
        positionWithAWB.packageCandidate ?? ({} as PackageCandidate)
      );
      return true;
    } else {
      setFeedbackMessage(AWB_FEEDBACK_NON_EXISTING_PIECE);
      return false;
    }
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      requestAWBValidation();
    }
  };
  const handleNumPad = (option: string) => {
    setFeedbackMessage('');
    //it triggers by pressing the enter key
    if (option === 'go') {
      requestAWBValidation();
      return;
    }
    if (option === 'back') {
      setAwbNumber(awbNumber.slice(0, -1));
      return;
    }
    if (awbNumber.length < AWB_VALID_LENGTH) {
      setAwbNumber(awbNumber + option);
    } else {
      setFeedbackMessage(AWB_FEEDBACK_LENGTH);
    }
  };
  const renderNumpad = () => {
    return (
      <div className="client-retrieval-scan-numpad-container">
        <NumPad
          onClickButton={(option) => {
            handleNumPad(option);
          }}
        />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className="locker-content-container">
        <div className="locker-content-container-left">
          <div className="client-retrieval-scan-awb-container">
            <ControlledNumericInput
              val={awbNumber}
              inputLabel="Número de Guía"
              inputPlaceholder="12 34546 7895"
              validationError={variableInError === 'awbNumber'}
              maxLength={10}
              maxNumber={9999999999}
              type="integer"
              onError={(isErr: boolean) => {
                if (isErr) {
                  let msg = languageMap.login.installation_id_error[language];
                  setVariableInError('awbNumber');
                  setFeedbackMessage(msg);
                } else {
                  setFeedbackMessage('');
                  setVariableInError('');
                }
              }}
              onTextChange={(newVal: string) => {
                setVariableInError('');
                setFeedbackMessage('');
                setAwbNumber(newVal);
              }}
              handleKeypress={handleKeypress}
              extraClassContainer="no-padding-right full-width stretched"
              extraClass="placeholder-left"
            />

            <div className="remove-awb-image-awb-container">
              <img id="awb-image" className="awb-image" src={AWB} alt="Guia" />
            </div>
          </div>
        </div>
        <div className="locker-content-container-right">{renderNumpad()}</div>
      </div>
    );
  };
  return (
    <div id="removeValidateAWB" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.remove_validate_awb.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_scan_awb.back_button[language]
                }
                buttonClass="navigation-button cancel-button complete"
                onClickButton={() => {
                  history.replace(
                    `/${navigationPages.REMOVE_PROCESS_SELECTION}`
                  );
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { RemoveValidateAWB };
